import { FAMILY_COLORS, FAMILY_LABELS } from "../_model";

interface FamilyDotProps {
  family: string;
  size?: number;
  /** Real color from the server family rel; falls back to the fixed palette. */
  color?: string | null;
  /** Real display label; falls back to the fixed palette, then the slug. */
  label?: string;
}

export function FamilyDot({ family, size = 8, color, label }: FamilyDotProps) {
  return (
    <span
      title={label ?? FAMILY_LABELS[family] ?? family}
      style={{
        width: size,
        height: size,
        borderRadius: 2,
        flexShrink: 0,
        background: color ?? FAMILY_COLORS[family] ?? "var(--ink-4)",
        display: "inline-block",
      }}
    />
  );
}
